import styled from '@emotion/styled';

export const StyledStrikeThroughPrice = styled.span(
  {
    textDecoration: 'line-through',
    display: 'block',
    lineHeight: '20px'
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium,
    color: theme.palette.colors.blackCoral,
    fontWeight: theme.typography.fontWeightLight
  })
);

export default StyledStrikeThroughPrice;
